import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { filterPageTypes } from 'src/app/store/filters.era';
import { allDefaultEventListColumns, eventListTableColumnsById, PublishDotMenuChoices } from 'src/app/helpers/table-helpers';
import { AllSameKeysToTypeEnforcer, removeOrAddToListByElement, removeFromListByIndex } from 'src/app/helpers/helpers';
import { ConfirmDeleteData, openConfirmDeleteGetResult } from 'src/app/components/dialog.confirmDelete.component';
import { openDialogGetResult } from 'src/app/helpers/angular-helpers';
import { TableColumn, TableMenuItem, TableDotMenuItem } from 'src/app/helpers/table.data';
import { EventListTableData, eventListTableColumns } from 'src/app/helpers/table-column-types';
import { EventListInfo, EventListPublishInstance, EventListsData, getDefaultEventListTabNames, getUpcomingAndPastEventListInstances, InstanceInfo, PublishedEventListsData, SortedEventListPublishInstances, UnpublishOrDeleteEventListsQuery } from 'globals/store/share.event-lists.data';
import { NewEventListDialogComponent, NewEventListDialogReturnData } from '../wizards/newEventList.dialog.component';
import { eventListInfoReselector, EventListSelectionsReselectorData, eventListsReselector, EventListsSelectionsData, eventListsSelectionsReselector, eventListsTableReselector } from 'src/app/store/reselectors/event-lists.reselector';
import { Dictionary } from '@ngrx/entity';
import { JoiAccount } from 'globals/store/accounts.data';
import { publishStatusToColor, publishStatusToText } from 'src/app/modules/program/program.publish.view.component';
import { publicHelpers } from './../../helpers/public-helpers';
import { SortOption, User } from 'globals/store/user.data';
import { Label } from 'globals/store/events.data';
import { LabelSelectorDialog } from '../publish-timeline/label-selector.dialog';
import { PublicEventData } from 'globals/store/public.model';
import { eventListDisplayOptions } from './event-list-display-options';
import { NestedChecksDialogComponent, NestedChecksDialogData, NestedChecksReturnData } from '../wizards/nested-checks.dialog.component';
import { ConfirmProgramPublishActionDialogComponent, ConfirmPublishActionDialogData } from 'src/app/modules/program/program.dialog.confirmPublishAction.component';
import { sleepForMS } from './../../helpers/helpers';
import { Wrapper } from '../wrapper.component';
import { BrandOption, BrandingData, BrandingSelectData, SliderImage, createEventListBuilderData } from 'globals/store/publish.data';
import { brandDataReselector } from '../../store/reselectors/publish.reselector';
import { EventThumbsData, EventThumbsDialogComponent } from '../branding/event-thumbs-dialog.component';
import { ManageBrandingComponent, ManageBrandingData } from '../branding/manage-branding.component';
import { SliderImageDialogComponent, SliderImageDialogData } from '../branding/slider-image-dialog.component';
import { flatten, getNestedSet, jsonCopyObject, setDifference } from 'globals/helpers/helpers';
import { traceNames } from 'src/app/services/performance.tracking.data';
import { ShareEventListService } from 'src/app/services/share.event-list.service';
import { shareActions } from 'src/app/store/share.era';
import { LabelSelectorData, SelectableLabelGroup } from 'globals/store/dialog.selector.data';
import { EventListComponent } from './event-list.component';
import { ShareCodeComponent } from 'src/app/modules/share/share-code.component';
import { CommonModule, DatePipe } from '@angular/common';
import { LabelItemComponent } from '../label-marker/label-item.component';
import { HomeWrapperComponent } from '../nav-bar/home-wrapper.component';
import { LoaderPaneFragmentComponent } from '../loader/loader-pane-fragment.component';
import { CommandMenuComponent } from '../nav-bar/command-menu.component';
import { NestedTableComponent } from '../nested-table/nested-table.component';
import { BlackBarWrapperComponent } from '../wrappers/black-bar-wrapper.component';
import { JoiNavWrapper } from '../wrappers/joi-nav-wrapper.component';
import { TrafficLightComponent } from '../misc/traffic-light.component';
import { IconTextComponent } from '../buttons/icon-text.component';
import { ExpandingWrapperComponent } from '../wrappers/expanding-wrapper.component';
import { TitleToggleComponent } from '../wrappers/title-toggle-wrapper.component';
import { MenuHoverButtonComponent } from '../buttons/menu-hover-button.component';
import { BrandingTextComponent } from '../branding/branding-text.component';
import { BrandingBlockWrapperComponent } from '../branding/branding-block.component';
import { SliderImageComponent } from '../branding/slider-image.component';
import { IconComponent } from '../icon/icon.component';
import { SortSelectComponent } from 'src/app/modules/dashboard/sort-select.component';
import { EventListsBuilderComponent } from '../branding/event-lists-builder.component';
import { MatButtonModule } from '@angular/material/button';

type EventListViewMode = 'SELECT' | 'DESIGN' | 'CONFIGURE' | 'PREVIEW' | 'PUBLISHED'

@Component({
    selector: 'event-lists',
    templateUrl: './event-lists.html',
    styleUrls: [`./event-lists.scss`, '../nested-table/nested-table.scss'],
    standalone: true,
    providers: [DatePipe],
    imports: [EventListComponent, MatButtonModule, ShareCodeComponent, CommonModule, EventListsBuilderComponent, SortSelectComponent, LabelItemComponent, HomeWrapperComponent, LoaderPaneFragmentComponent, CommandMenuComponent, NestedTableComponent, BlackBarWrapperComponent, JoiNavWrapper, TrafficLightComponent, IconTextComponent, ExpandingWrapperComponent, TitleToggleComponent, MenuHoverButtonComponent, BrandingTextComponent, BrandingBlockWrapperComponent, SliderImageComponent, IconComponent],
})
export class EventListsComponent extends Wrapper<EventListsComponent> implements OnInit, OnDestroy {

  readonly _file: string = "event-lists.component.ts";
  private $selectTimeline: Subject<boolean> = new Subject()
  filterPage = filterPageTypes.eventList
  publishCode: string
  publishSelected = false
  loaded = false
  message = ''
  oneWillUpdateMessage = "1 page will be updated immediately."
  oneUpdatedMessage = "1 page was updated successfully"
  searchTerm = ''
  selectedViewMode: EventListViewMode
  viewModes: EventListViewMode[] = ['SELECT', 'DESIGN', 'CONFIGURE', 'PREVIEW', 'PUBLISHED']
  statusToColor = publishStatusToColor
  statusToText = publishStatusToText

  canUpdateCount = 0
  MESSAGE_DISPLAY_MS = 5000
  selectedRowIds: Set<string> = new Set()
  accounts: Dictionary<JoiAccount>
  accountId: string
  accountLabels: { [id: string]: Label }
  publishToggleStates = ["DON'T INCLUDE", "INCLUDE"]
  addInstanceHint = "Adding a new instance allows you to\ndisplay an event multiple times in your\nevent list. This is useful in the case of a\nroadshow if you want to display each\nlocation separately."
  openEventSelectionsIds: Set<string> = new Set()
  allEventSelectionsOpen = false
  selectedEventLabels: Set<string> = new Set()
  filteredOutEventIds: Set<string> = new Set()

  columnData: TableColumn[] = allDefaultEventListColumns
  columnsById: { [id: string]: TableColumn } = eventListTableColumnsById
  singleSelectionMenuItems: TableMenuItem[] = [
    { title: 'Edit', method: this.editEventListDetailsFromTableMenu.bind(this) },
  ]
  multiSelectionMenuItems: TableMenuItem[] = [
    { title: 'Delete', method: this.deleteEventLists.bind(this) }
  ]
  menuItems: TableMenuItem[] = []
  dotMenuItems: AllSameKeysToTypeEnforcer<Omit<PublishDotMenuChoices, 'update'>, TableDotMenuItem> = {
    view: { id: 'view', title: 'View', method: this.openEventListFromTable.bind(this) },
    edit: { id: 'edit', title: 'Edit', method: this.editSingleEventListDetails.bind(this) },
    delete: { id: 'delete', title: 'Delete', method: this.deleteEventList.bind(this) },
    duplicate: { id: 'duplicate', title: 'Duplicate', method: this.duplicateEventList.bind(this) },
  }

  defaultColumnId = eventListTableColumns.name
  eventListsRows: EventListTableData[] = []
  eventListTableRowsById: { [id:string]: EventListTableData } = {}
  eventListSelections: EventListsSelectionsData[]
  loadedTableDataOnce = false
  rowsBeforeFiltering = 0
  helpers = publicHelpers
  learnMoreLink = "https://www.joi.events/features" // <== NEED TO CHANGE!
  subscribedPublishShareablesAccountIds = new Set()
  publishedEventDataMap: {[key:string]: PublicEventData } = {}

  upcomingAndPastPublishedEventLists: SortedEventListPublishInstances
  publishesLoading = 0
  eventListsFullData: EventListsData
  selectedEventListInfo: EventListInfo

  publishing = false
  loadedDatas: { [publishId: string]: PublishedEventListsData } = {}
  publishedData: PublishedEventListsData
  

  publishLoading = false
  showSuccess = false;
  
  upcomingAndPastEventLists: SortedEventListPublishInstances
  user: User
  brandingData: BrandingData
  traceNames = traceNames

  constructor(
    private shareEventListsService: ShareEventListService,
  ) {
    super()
    this.uiService.changePageTitle("Publish Event Lists", true)
    this.subProp(this.store.select('shareables', 'published_data'), 'publishedEventDataMap')
    this.subProp(this.store.select('user', 'user'), 'user')
  }

  succeedTemporarily() { // as we all know, success is ephemeral =0 =0 =0
    this.showSuccess = true
    setTimeout(() => this.showSuccess = false, 3000)
  }

  async changeBrandingOption(brandingOption: BrandOption) {
    console.log("Should be opening branding options dialogue and changing " + brandingOption)
    const data: ManageBrandingData = { selectedTab: brandingOption, type: 'list', eventListId: this.selectedEventListInfo.publishCode, accountId: this.accountId, outsideEvent: true, onAccount: true }
    await openDialogGetResult(this.dialog, ManageBrandingComponent, { disableClose: true, autoFocus: false, data, panelClass: 'full-screen-modal' })
  }

  async preloadPreviewData() {
    const allSelectedPublishIds = getNestedSet(flatten(this.eventListSelections.map(s => s.instances)), 'publishIds')
    const missingIds = setDifference(allSelectedPublishIds, new Set(Object.keys(this.publishedEventDataMap)))
    this.publishesLoading += missingIds.size
    console.log({ allSelectedPublishIds, missingIds, publishesLoading: missingIds.size, eventListSelections: this.eventListSelections, publishedEventDataMap: this.publishedEventDataMap })
    missingIds.forEach(id => this.sharePublishService.downloadAndDispatchPublishedEvent(id, true).then(() => {
      this.publishesLoading = Math.max(0, this.publishesLoading - 1)
    })) // <== loads to store
  }

  async editSliderImage(index: number) {
    const data: SliderImageDialogData = {
      sliderImage: index === null ? null : this.selectedEventListInfo.homePageData.sliderImages[index],
      accountId: this.accountId,
      imageType: 'event-thumb'
    }
    const sliderImage = await this.openDialogGetResult<SliderImage | { delete: true }>(SliderImageDialogComponent, { width: '440px', disableClose: true, data })
    if (!sliderImage) return
    if ('delete' in sliderImage) {
      removeFromListByIndex(this.selectedEventListInfo.homePageData.sliderImages, index)
    } else if (index === null) {
      if (!this.selectedEventListInfo.homePageData.sliderImages) this.selectedEventListInfo.homePageData.sliderImages = []
      this.selectedEventListInfo.homePageData.sliderImages.push(sliderImage)
    } else {
      this.selectedEventListInfo.homePageData.sliderImages[index] = sliderImage
    }
    this.saveEventListInfo()
  }

  async changeViewMode(viewMode: EventListViewMode) {
    this.selectedViewMode = viewMode
    // console.log({ viewMode })
    if (viewMode === 'SELECT') await this.checkForPublishInfos()
    if (viewMode === 'PREVIEW' || viewMode === 'CONFIGURE' || viewMode === 'DESIGN') {
      await this.checkForPublishInfos()
      await this.preloadPreviewData()
    }
    if (viewMode === 'PUBLISHED') {
      const info = this.selectedEventListInfo
      this.publishedData = this.loadedDatas[info.publishCode]
      if (info.status === 'published' && !this.publishedData) {
        this.publishLoading = true
        const eventList = await this.shareEventListsService.downloadEventList(info.publishCode)
        // console.log({ eventList })
        this.publishLoading = false
        if (!eventList) {
          console.log(`Could not get event list of id ${info.publishCode}!`)
          return
        }
        this.loadedDatas[info.publishCode] = eventList
        this.publishedData = eventList
      }
      this.getPublishedDataReady()
    }
  }

  getPublishedDataReady() {
    if (!this.publishedData) return
    this.upcomingAndPastPublishedEventLists = getUpcomingAndPastEventListInstances(this.publishedData.instances)
  }

  toggleSelection(eventId: string) {
    // console.log(`toggleSelection called for eventId: [${eventId}]`)
    if (this.openEventSelectionsIds.has(eventId)) this.openEventSelectionsIds.delete(eventId)
    else this.openEventSelectionsIds.add(eventId)
    this.allEventSelectionsOpen = this.eventListSelections.length  === this.openEventSelectionsIds.size
  }

  expandOrCollapseAll() {
    console.log("Expand or collapse all not implemented yet")
    if (this.allEventSelectionsOpen) this.openEventSelectionsIds = new Set()
    else this.eventListSelections.forEach(e => this.openEventSelectionsIds.add(e.eventId))

    this.allEventSelectionsOpen = !this.allEventSelectionsOpen
  }

  togglePublishInfo(selections: EventListsSelectionsData, instanceIndex: number, publishCode: string) {
    const removed = removeOrAddToListByElement(selections.instances[instanceIndex].publishIds, publishCode)
    selections.totalSelected += removed ? -1 : 1
    this.updateSelections(null)
  }


  updateSelections(instanceThumbs: Dictionary<string[]>) {
    const eventListInfos = this.accounts[this.accountId].eventListInfos
    const info = eventListInfos[this.publishCode]
    const eventInstanceMap: { [eventId: string]: InstanceInfo[] } = {}
    this.eventListSelections.map(selections => {
      eventInstanceMap[selections.eventId] = selections.instances
    }) 
    info.eventInstanceMap = eventInstanceMap
    if (instanceThumbs) info.instanceThumbs = instanceThumbs
    eventListInfos[this.publishCode] = info
    this.accountService.updateEventListInfos(this.accountId, eventListInfos)
  }

  async editDisplayOptions() {

    const data: NestedChecksDialogData = {
      title: 'Display options',
      successLabel: 'SAVE',
      deselectedIds: this.selectedEventListInfo.excludedFieldIds || [],
      backgroundColor: this.uiService.labelsByType.event.color,
      nestedCheckGroups: eventListDisplayOptions,
      tabNameMap: this.selectedEventListInfo.tabNames,

    }

    console.log(data)
    const result = await openDialogGetResult<NestedChecksReturnData>(this.dialog, NestedChecksDialogComponent, { width: '480px', disableClose: true, data })

    if (!result) return
    
    const eventListInfos = this.accounts[this.accountId].eventListInfos
    const info = eventListInfos[this.publishCode]
    info.tabNames = result.tabNameMap
    info.excludedFieldIds = result.deselectedIds
    this.accountService.updateEventListInfos(this.accountId, eventListInfos)
    console.log(result)
  }

  ngOnInit() {

    this.subProp(this.store.select('filters', 'eventList', 'search'), 'searchTerm')
    this.subProp(this.store.select('accounts', 'entities'), 'accounts')
    this.selectCallback<{
    eventListTableData: EventListTableData[];
    eventListTableRowsById: {
        [key: string]: EventListTableData;
    };
    eventListsCountBeforeFiltering: number;
}, any>(eventListsTableReselector, null, ({ eventListTableData, eventListTableRowsById, eventListsCountBeforeFiltering }) => {
      this.eventListsRows = eventListTableData
      this.eventListTableRowsById = eventListTableRowsById
      this.rowsBeforeFiltering = eventListsCountBeforeFiltering
      this.loadedTableDataOnce = true
    })
 
  }

  async addEventList() {
    const result = jsonCopyObject(await openDialogGetResult<NewEventListDialogReturnData>(this.dialog, NewEventListDialogComponent, { width: '480px', disableClose: true }))
    if (!result) return
    const { name, description, account } = result
    const { id, eventListInfos } = account
    const publishCode = await this.shareService.createSlugCode()
    const { firstName, lastName, uid } = this.user
    const eventListInfo: EventListInfo = {
      title: name,
      description: description || null,
      status: 'never published',
      excludedFieldIds: [],
      tabNames: getDefaultEventListTabNames(),
      publishCode,
      creator: `${firstName} ${lastName}`,
      creatorUid: uid,
      createdAt: new Date().getTime(),
      eventInstanceMap: {},
      sortOption: { event_order_key: 'first_date', event_order_rev: true },
      homePageData: createEventListBuilderData()
    }
    eventListInfos[publishCode] = eventListInfo
    await this.accountService.updateEventListInfos(id, eventListInfos)
    this.openEventList(id, publishCode)
  }
 
  selectIds(ids: Set<string>) {
    setTimeout(() => {
      this.canUpdateCount = Array.from(ids).reduce((tot, id) => tot + (this.eventListTableRowsById[id].eventListInfo.status === 'published' ? 1 : 0), 0)
      this.menuItems = ids.size === 1 ? [...this.singleSelectionMenuItems, ...this.multiSelectionMenuItems] : [...this.multiSelectionMenuItems]
      // if (this.canUpdateCount === ids.size) this.menuItems.unshift({ title: 'Update', method: this.updateEventLists.bind(this) })
    }, 0)
  }

  
  closeEventList() {
    this.publishCode = null;
    this.selectedEventListInfo = null;
    this.$selectTimeline.next(true)
  }

  async openEventList(accountId: string, publishCode: string, isPublished = false) {
    this.$selectTimeline.next(true)
    const brandingSelectData: BrandingSelectData = {
      type: 'list',
      eventListId: publishCode,
      accountId: accountId
    }
    this.selectProp(brandDataReselector, brandingSelectData, 'brandingData', this.$selectTimeline)  

    const extraArgs = { accountId, publishCode }
    this.selectCallback(eventListInfoReselector, extraArgs, (eventListInfo: EventListInfo) => {
      // console.log({ eventListInfo })
      this.selectedEventListInfo = jsonCopyObject(eventListInfo)
    }, this.$selectTimeline)

    this.selectCallback(eventListsReselector, { accountId, eventListInfoId: publishCode }, (data:  EventListsData) => {
      if (!data) return
      const upcomingAndPastEventListInstances = getUpcomingAndPastEventListInstances(data.instances)
      this.eventListsFullData = data
      this.upcomingAndPastEventLists = upcomingAndPastEventListInstances
      // console.log(data, upcomingAndPastEventListInstances)
    }, this.$selectTimeline) 

    this.selectCallback(eventListsSelectionsReselector, { accountId, eventListInfoId: publishCode }, (data: EventListSelectionsReselectorData) => {
      if (!data) return
      const { accountLabels, eventListSelections } = data
      // console.log({ eventListSelections, accountLabels })
      this.eventListSelections = eventListSelections
      this.accountLabels = accountLabels

    }, this.$selectTimeline)
    this.accountId = accountId
    this.publishCode = publishCode
    if (isPublished) this.changeViewMode('PUBLISHED')
    else {
      await this.checkForPublishInfos()
      this.selectedViewMode = 'SELECT'
    }
  }

  async checkForPublishInfos() {
    if (!this.subscribedPublishShareablesAccountIds.has(this.accountId)) {
      this.subscribedPublishShareablesAccountIds.add(this.accountId)
      await this.shareService.getPublishShareablesFromAccountId(this.accountId, this.$destroy)
      await sleepForMS(50)
    } 
  }


  openEventListFromTable({ eventListInfo, account }: EventListTableData) {
    this.openEventList(account.id, eventListInfo.publishCode, eventListInfo.status === 'published')
  }

  async filterEvents() {
    const el: HTMLElement = document.getElementById(`event-filters`)
    const rect = el.getBoundingClientRect()
    const { bottom, right } = rect

    const allEventLabels = getNestedSet(this.eventListSelections, 'labels')
    const accountLabels = this.accounts[this.accountId].labels.filter(l => allEventLabels.has(l.id))
    const labelGroups: SelectableLabelGroup[] = [{
      name: 'LABELS', 
      labels: accountLabels.map(l => ({ ...l, selected: this.selectedEventLabels.has(l.id) }))
    }]
    const data: LabelSelectorData = {
      isMobile: false,
      position: { left: right - 290, top: bottom + 4 },
      labelGroups,
      template: this.brandingData.template
    }
    const labels: SelectableLabelGroup[] = await openDialogGetResult<SelectableLabelGroup[]>(this.dialog, LabelSelectorDialog, { width: '290px', disableClose: false, autoFocus: false, data, backdropClass: 'clear' })
    this.selectedEventLabels = new Set(labels[0].labels.filter(l => l.selected).map(l => l.id))
    this.filteredOutEventIds = !this.selectedEventLabels.size ? new Set() : new Set(this.eventListSelections.filter(e => !e.labels.some(l => this.selectedEventLabels.has(l))).map(e => e.eventId))
  }


  duplicateEventList(eventListTableItem: EventListTableData, event) {
    console.log("DUPLICATE NOT IMPLEMENTED!", eventListTableItem)
  }

  
  getCodeAccountIdFromCurrentlySelectedInfo() {
    const publishCode = this.selectedEventListInfo.publishCode
    const accountId = this.eventListTableRowsById[publishCode].account.id
    return { publishCode, accountId }
  }

  saveSorting(sortOption: SortOption) {
    const { publishCode, accountId } = this.getCodeAccountIdFromCurrentlySelectedInfo()
    const eventListInfos = this.accounts[accountId].eventListInfos
    eventListInfos[publishCode].sortOption = sortOption
    this.accountService.updateEventListInfos(accountId, eventListInfos)
  }

  async saveEventListInfo() {
    console.log("Should be saving event list info")
    this.accountService.updateEventListInfo(this.accountId, this.selectedEventListInfo)
  }

  
  addInstance(selections: EventListsSelectionsData, selectionIndex, instanceIndex: number) {
    console.log({ selectionIndex, instanceIndex })
    selections.instances.push({ publishIds: [] })

    const { eventId } = this.eventListSelections[selectionIndex]
    const instanceThumbs = this.selectedEventListInfo.instanceThumbs
    if (!instanceThumbs[eventId]) instanceThumbs[eventId] = selections.instances.map(i => null)
    else instanceThumbs[eventId].push(null)

    this.updateSelections(instanceThumbs)
  }

  removeInstance(selections: EventListsSelectionsData, selectionIndex, instanceIndex: number) {
    console.log({ selectionIndex, instanceIndex })
    removeFromListByIndex(selections.instances, instanceIndex)

    const { eventId } = this.eventListSelections[selectionIndex]
    const instanceThumbs = this.selectedEventListInfo.instanceThumbs
    if  (!instanceThumbs[eventId]) instanceThumbs[eventId] = selections.instances.map(i => null)
    else removeFromListByIndex(selections.instances, instanceIndex)

    this.updateSelections(instanceThumbs)
  }

  async editEventThumbnail(instance: EventListPublishInstance) {
    // just figured out that there is no way to attach a thumbnail to an instance properly since they don't have ids but exist as a list instead
    const eventId = instance.eventId

    const instanceThumbs = this.selectedEventListInfo.instanceThumbs || {}
    if (!instanceThumbs[instance.eventId]) {
      const eventListSelection = this.eventListSelections.find(s => s.eventId === instance.eventId)
      instanceThumbs[instance.eventId] = eventListSelection.instances.map(i => null)
    }
    const accountId = this.accountId
    const data: EventThumbsData = { accountId, thumbLink: instanceThumbs[eventId][instance.index] || null }
    const oldThumb = data.thumbLink
    await openDialogGetResult(this.dialog, EventThumbsDialogComponent, { disableClose: true, autoFocus: false, data, panelClass: 'full-screen-modal' })
    if (oldThumb !== data.thumbLink) {
      instanceThumbs[eventId][instance.index] = data.thumbLink
      this.selectedEventListInfo.instanceThumbs = instanceThumbs
      await this.accountService.updateEventListInfo(accountId, this.selectedEventListInfo)
    }
  }

  async confirmPublishAction(publish: boolean) {
    const data: ConfirmPublishActionDialogData = { publish, currently_published: this.selectedEventListInfo.status === 'published', isEventList: true }
    return await openDialogGetResult(this.dialog, ConfirmProgramPublishActionDialogComponent, { width: '480px', disableClose: true, data })
  }

  async unpublishSelectedEventList() {
    const confirmed = await this.confirmPublishAction(false)
    if (!confirmed) return
   
    const { publishCode, accountId } = this.getCodeAccountIdFromCurrentlySelectedInfo()
    const query: UnpublishOrDeleteEventListsQuery = { accountId, publishCode, command: 'unpublish', date: new Date().getTime() }
    delete this.loadedDatas[publishCode]
    this.publishedData = null
    this.shareEventListsService.unpublishOrDeleteEventList(query) 

  }

  async publishOrUpdateEventList() {
    const confirmed = await this.confirmPublishAction(true)
    if (!confirmed) return

    this.publishing = true
    const { publishCode, accountId } = this.getCodeAccountIdFromCurrentlySelectedInfo()

    const data: PublishedEventListsData = jsonCopyObject({ ...this.eventListsFullData, info: this.accounts[accountId].eventListInfos[publishCode], brandingData: this.brandingData })
    await this.shareEventListsService.publishOrUpdateEventList(data)
    this.loadedDatas[publishCode] = data
    this.succeedTemporarily()
    this.changeViewMode('PUBLISHED')
    this.publishing = false
  }

  deleteEventList(eventListTableItem: EventListTableData, event) {
    this.deleteEventLists([eventListTableItem], event)
  }
  
  async deleteEventLists(eventListTableData: EventListTableData[], event) {
    const n = eventListTableData.length
    const data: ConfirmDeleteData = {
      title: `Delete Event List${n === 1 ? '' : 's'}`,
      rect: event.target.getBoundingClientRect(),
      para: `Are you sure you want to delete ${n === 1 ? 'this' : 'these ' + n} event list${ n === 1 ? '' : 's'}?  This action cannot be undone`,
      deleteButtonText: 'DELETE',
      dialog: this.dialog
    }
    const del = await openConfirmDeleteGetResult(data)
    if (!del) return

    const eventListsToDeleteByAccount: { [id:string]: string[] } = {}
    eventListTableData.forEach(({ id, account }) => {
      if (!eventListsToDeleteByAccount[account.id]) eventListsToDeleteByAccount[account.id] = []
      eventListsToDeleteByAccount[account.id].push(id)
    })

    await Promise.all(Object.entries(eventListsToDeleteByAccount).map(async([accountId, eventListIds ]) => {
      const eventListInfos = this.accounts[accountId].eventListInfos
      await Promise.all(eventListIds.map(id => {
        const info = eventListInfos[id]
        if (this.publishedData && this.publishedData.id === id) this.publishedData = null
        delete eventListInfos[id]
        if (info.status === 'published') {
          const query: UnpublishOrDeleteEventListsQuery = { accountId, publishCode: id, command: 'delete', date: new Date().getTime() }
          delete this.loadedDatas[id]
          return this.shareEventListsService.unpublishOrDeleteEventList(query)
        } else return Promise.resolve() // unpublished means already deleted
      }))
      this.accountService.updateEventListInfos(accountId, eventListInfos)
      return Promise.resolve()
    }))
  }
  
  openGreenInputDialog(title: string, header: string, placeholder: string, successLabel: string, currentValue: string = null, emptyOK = false, secondValue: string = null, secondPlaceholder: string = null) {
    return this.openInputDialog(this.uiService.labelsByType.event.color, title, header, placeholder, successLabel, currentValue, emptyOK, secondValue, secondPlaceholder)
  }

  editEventListDetails() {
    this.editSingleEventListDetails(this.eventListTableRowsById[this.selectedEventListInfo.publishCode])
  }

  editEventListDetailsFromTableMenu(eventListRows: EventListTableData[]) {
    this.editSingleEventListDetails(eventListRows[0])
  }

  async editSingleEventListDetails({ eventListInfo, account }: Partial<EventListTableData>) {
    const result = await this.openGreenInputDialog('Edit Name and Description', 'Update your event list name and description', 'Event list name', 'UPDATE', eventListInfo.title, false, eventListInfo.description, 'Description')
    if (!result) return
    const [ title, description ] = result.values
    const eventListInfos = this.accounts[account.id].eventListInfos
    eventListInfos[eventListInfo.publishCode] = {...eventListInfo, title, description: description || null }
    this.accountService.updateEventListInfos(account.id, eventListInfos)
  }

  setMessage(message: string) {
    this.message = message
    setTimeout(() => this.message = '', this.MESSAGE_DISPLAY_MS)
  }


  trackBySelections(_, selections: EventListsSelectionsData) { return selections.eventId }
  trackByIndex(index) { return index }

  ngOnDestroy() { 
    this.store.dispatch(shareActions.eventListUnload())
    this.$selectTimeline.next(true); 
    this.$selectTimeline.complete(); 
  }

}

